import { Observable } from 'rxjs';
import { UseCase } from '@/core/base/use-case';
import { CheckReservation } from '../models/check-body.model';
import { CheckReservationResponse } from '../models/check-response.model';
import { CheckReservationRepository } from '../repositories/check-reservation.repository';

export class CheckReservationUseCase
    implements UseCase<CheckReservation, CheckReservationResponse>
{
    constructor(private readonly repository: CheckReservationRepository) {}

    execute(
        checkReservation: CheckReservation,
    ): Observable<CheckReservationResponse> {
        return this.repository.checkReservation(checkReservation);
    }
}
